// 组件对象，大写
import crudDoubleQuerys from './crudDoubleQuerys.vue'
export default crudDoubleQuerys
